<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">JSA Paper Submission</h1>
  <p class="form-desc">This form must be filled out prior to the start of each new job & every day for each crew on location.
    This must also be re-visited and readdressed if conditions change in the scope of work or environment.
  If utilising a pre-written JSA for the day, every step must be reviewed verbally and site specific information must be added to the JSA.</p>
</div>
<br>

  <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      <p class="note">This is a paper submission for the JSA. You should only utilize this form if you were unable to submit the Electronic JSA from the work site.</p>
      <br>
        <form [formGroup]="form" appSubmitDiag="jsapaper" (ngSubmit)="create()">

          <mat-form-field appearance="fill">
            <mat-label>Email:</mat-label>
            <input matInput placeholder="Enter email" formControlName="email" required>
          </mat-form-field>
          <br>

            <mat-form-field appearance="fill">
              <mat-label>Date:</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date" required>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>


            <mat-label>Upload PDF or Image File:</mat-label>
            <br><br>
            <!-- Upload File Section -->
            <div class="file-upload-wrapper">
              <input id="file-upload" type="file" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png" class="upload-text" formControlName="file">
            </div>
            <br>

              <!-- Office Reporting To -->
              <mat-form-field appearance="fill">
                <mat-label>Office Reporting To:</mat-label>
                <mat-select formControlName="office" required>
                  <mat-option value="houston">Houston</mat-option>
                  <mat-option value="ftworth">Ft. Worth</mat-option>
                  <mat-option value="austin">Austin</mat-option>
                  <mat-option value="irving">Irving</mat-option>
                  <mat-option value="frisco">Frisco</mat-option>
                  <mat-option value="bossiercity">Bossier City</mat-option>
                  <mat-option value="magnolia">Magnolia</mat-option>
                  <mat-option value="windsor">Windsor</mat-option>
                  <mat-option value="midland">Midland</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Full Name:</mat-label>
                <input matInput placeholder="Enter your name" formControlName="name" required>
              </mat-form-field>

              <br><br>
              <div class="button-container">
                <button mat-raised-button color="primary" class="submit-button" [disabled]="isSubmitting">{{ isSubmitting ? 'Submitting…' : 'Submit' }}</button>
              </div>

              @if (isSubmitting) {
                <div class="custom-spinner-container">
                  <div class="custom-spinner"></div>
                </div>
              }

              @if (!isSubmitting && form.invalid && form.touched) {
                <div class="error-message">
                  Please fill in all required fields.
                </div>
              }

              @if (warningMessage) {
                <div class="error-message">{{ warningMessage }}</div>
              }

            </form>
          </mat-card-content>
        </mat-card>
        <br><br>

        <div class="page-title">
          <p class="form-desc-two">If form does not submit, ensure all required fields are answered. Additionally, depending on the network, the form submission may take a minute. If it still does not submit, reach out directly to <i class="contact">(pturner&#64;landpoint.net)</i> to get it handled. </p>
        </div>